
/*
* The request was made but no response was received, `error.request`
* is an instance of XMLHttpRequest in the browser and an instance
* of http.ClientRequest in Node.js
*/
export const isUserNetworkError = (error) => error && !error.response && error.request;
